import React, { useState, useRef, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import "./Sidebar.css";
import knowledgeLogo from "./../../ms-knowledge-logo (1).svg";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { toast } from "react-toastify";
import axios from "axios";
import { ViewContext } from "../../context/ViewContext";
import { Tree } from "primereact/tree";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import knowledgeshortLogo from "../../assets/images/icons/knowledge_short_logo.svg";
import { PiTreeStructureThin } from "react-icons/pi";
import { BsCardHeading, BsChevronDoubleLeft } from "react-icons/bs";
import { FiBook } from "react-icons/fi";
import { GrRefresh } from "react-icons/gr";
import { BsFillPinFill } from "react-icons/bs";
import { CgMenu } from "react-icons/cg";
import { AiOutlineLogout } from "react-icons/ai";
import { BsChevronDoubleRight } from "react-icons/bs";
import { Spinner } from "react-bootstrap";

import {
  clearGraphData,
  fetchGraphDataThunk,
  handleTopicSelectionThunk,
  unpinAllNodes,
  setSelectedLeafClasses,
  toggleCollapseAll,
  resetGraph,
  addToFilter,
  fetchFilteredGraphData,
  handleTagChangeThunk,
  setIsCopyLink,
} from "../../redux/slices/graphSlice";
import { logoutThunk, updateCurrentRole } from "../../redux/slices/authSlice";
import {
  setIncludeClasses,
  setIncludeTopics,
  resetFilters,
} from "../../redux/slices/graphSlice";
import FileUploadModal from "../common/FileUploadModal";
import api from "../../api/apiClient";
import { useUserId } from "../../Utils/helpers";
import { useSidebar } from "../../context/SidebarContext";
import { useAuthWatcher } from "../../auth/useAuthWatcher";
import { FaDownload } from "react-icons/fa";

const SidebarComponent = ({ onButtonClick }) => {
  const { REACT_APP_API_ENDPOINT, REACT_APP_LOGIN_REDIRECT_URL } = process.env;

  const { setViewType, viewType } = useContext(ViewContext);
  const {
    pinnedNodes,
    expandedNodes,
    expandedNodesCount,
    totalNodesCount,
    filters,
  } = useSelector((state) => state.graph);

  const { setShowDraftModals, attachments, isExpanded, setIsExpanded } =
    useSidebar(); // Use existing context

  const { user } = useSelector((state) => state.auth);
  const currentRole = localStorage.getItem("currentRole");
  const role = localStorage.getItem("role");
  const dispatch = useDispatch();
  const userId = useUserId();
  const [isEditorMode, setIsEditorMode] = useState(
    currentRole ? currentRole === "editor" : true
  );
  const [preserveFilters, setPreserveFilters] = useState(true);
  const isSuperAdmin = user?.userRole === "superuser";

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedNodeKeys, setSelectedNodeKeys] = useState({});
  const [selectedTopicKeys, setSelectedTopicKeys] = useState({});
  const [expandedNodeKeys, setExpandedNodeKeys] = useState({});
  const [expandedTopicKeys, setExpandedTopicKeys] = useState({});

  const [nodes, setNodes] = useState([]);
  const [topics, setTopics] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isClassNodesLoading, setIsClassNodesLoading] = useState(false);
  const [isTopicNodesLoading, setIsTopicNodesLoading] = useState(false);

  useAuthWatcher();

  useEffect(() => {
    loadTreeData();
    loadTopicsData();
  }, []);

  const loadTreeData = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_ENDPOINT}/schema/graph`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem("authToken")}`,
          },
        }
      );

      const schemaData = response.data;
      // setNodes(response.data);

      try {
        if (schemaData) {
          // Filter edges to remove self-loops (edges where source and target are the same)
          const filteredEdges = schemaData.edges?.filter(
            (edge) => edge.source !== edge.target
          );
          schemaData.edges = filteredEdges;

          const transformedNodes = buildFilteredTreeStructure(
            schemaData.nodes,
            schemaData.edges
          );
          setNodes(adaptDataForPrimeReact(transformedNodes));
        }
      } catch (err) {}
    } catch (error) {
      console.error("Failed to load schema graph:", error);
    }
  };

  const handleUnpinAll = () => {
    dispatch(unpinAllNodes());
  };

  const handleResetAll = (e) => {
    e.preventDefault();
    dispatch(resetFilters());
    dispatch(clearGraphData());
    setSelectedNodeKeys({});
    setSelectedTopicKeys({});
  };

  const handleReset = () => {
    dispatch(resetFilters());
    // if (expandedNodes.size > 0 || allExpandedNodes.size > 0) {
    //   // If there are expanded nodes, use context-based reset
    //   triggerGraphReset();
    // } else {
    // If no expanded nodes, use normal Redux reset
    // dispatch(removeAllExpandedNodes());
    dispatch(resetGraph({ userId }));

    // }

    setSelectedNodeKeys({});
    setSelectedTopicKeys({});
  };

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  const loadTopicsData = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_ENDPOINT}/topics/${userId}/`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem("authToken")}`,
          },
        }
      );

      const topicsData = response.data;

      if (
        topicsData &&
        Array.isArray(topicsData.nodes) &&
        Array.isArray(topicsData.edges)
      ) {
        // Filter edges to remove self-loops (edges where source and target are the same)
        const filteredEdges = topicsData.edges.filter(
          (edge) => edge.source !== edge.target
        );
        topicsData.edges = filteredEdges;
        const transformedTopics = FilteredTopicStructure(
          topicsData.nodes,
          topicsData.edges
        );
        setTopics(adaptDataForPrimeReact(transformedTopics));
      } else {
        console.error("Invalid data format:", topicsData);
      }
    } catch (error) {
      console.error("Failed to load topics:", error);
    }
  };

  const buildFilteredTreeStructure = (nodes, edges) => {
    // Filter nodes based on class_kind "node"
    const filteredNodes = nodes.filter((node) => node.class_kind === "node");

    // Create a map of nodes by id for quick access
    const nodeMap = new Map(
      filteredNodes.map((node) => [
        node.id,
        {
          value: `${node.name.toLowerCase().replace(/\s+/g, "")}_${node.id}`, // Append ID for uniqueness
          label: node.name,
          children: [],
        },
      ])
    );

    // Build the tree using the edges by assigning children to their parents
    edges.forEach((edge) => {
      // Check if the source and target of the edge are the same
      if (edge.source !== edge.target) {
        const childNode = nodeMap.get(edge.source);
        const parentNode = nodeMap.get(edge.target);
        if (parentNode && childNode) {
          parentNode.children.push(childNode);
        }
      }
    });

    // Find the root node (starting point "Any")
    const rootNode = Array.from(nodeMap.values()).find(
      (node) => node.label === "Any"
    );

    // Optional: Remove nodes from the map that have been assigned as children
    const rootNodeIds = new Set();
    const markChildren = (node) => {
      rootNodeIds.add(node.value);
      node.children.forEach((child) => markChildren(child));
    };
    markChildren(rootNode);
    const result = Array.from(nodeMap.values()).filter(
      (node) => !rootNodeIds.has(node.value)
    );

    // Add the root node at the beginning of the results array
    result.unshift(rootNode);
    return result;
  };

  const FilteredTopicStructure = (nodes, edges) => {
    const filteredNodes = nodes.filter(
      (node) => node.class === "Topic" && node.props.name
    );

    const nodeMap = new Map();
    const usedValues = new Set();

    // Process each node and ensure unique values
    filteredNodes.forEach((node) => {
      let baseValue = `${node.props.name.toLowerCase().replace(/\s+/g, "")}_${
        node.id
      }`;
      let uniqueValue = baseValue;

      let counter = 1;
      while (usedValues.has(uniqueValue)) {
        uniqueValue = `${baseValue}_${counter}`;
        counter++;
      }

      nodeMap.set(node.id, {
        value: uniqueValue,
        label: node.props.name,
        description: node.props?.desc || "",
        children: [],
      });

      usedValues.add(uniqueValue);
    });

    // Map edges by their source node
    const edgesBySource = new Map();
    edges.forEach((edge) => {
      if (!edgesBySource.has(edge.source)) {
        edgesBySource.set(edge.source, []);
      }
      edgesBySource.get(edge.source).push(edge.target);
    });

    // Recursive function to build the tree structure
    const buildTree = (nodeId, parentPath = "") => {
      const node = nodeMap.get(nodeId);
      if (!node) return null; // If node doesn't exist, return null

      // Ensure unique value for each occurrence of a node
      let baseValue = node.value;
      let uniqueValue = baseValue;
      let counter = 1;

      // Use parentPath to ensure uniqueness
      while (usedValues.has(uniqueValue)) {
        uniqueValue = `${baseValue}_${counter}`;
        counter++;
      }

      usedValues.add(uniqueValue);
      const newNode = { ...node, value: uniqueValue, children: [] };

      const childIds = edgesBySource.get(nodeId) || [];
      childIds.forEach((childId) => {
        const childNode = buildTree(childId, uniqueValue); // Recursively build child tree
        if (childNode) {
          newNode.children.push(childNode);
        }
      });

      return newNode;
    };

    // Find the root node (All Topics)
    const rootNodeId = Array.from(nodeMap.keys()).find(
      (id) => nodeMap.get(id).label === "All Topics"
    );

    const result = [];

    if (rootNodeId) {
      const rootNode = buildTree(rootNodeId); // Start recursive tree building
      if (rootNode) {
        result.push(rootNode); // Add the root node to the result
      }
    }
    return result;
  };

  const adaptDataForPrimeReact = (data) => {
    const sortNodes = (nodes) => {
      return nodes.sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0;
      });
    };

    const adapt = (node) => ({
      key: node.value,
      label: node.label,
      description: node.description,
      children: node.children ? sortNodes(node.children).map(adapt) : undefined,
    });
    return sortNodes(data).map(adapt);
  };

  // Add new classes to filter
  const handleAddClasses = (newClasses) => {
    dispatch(
      addToFilter({
        filterType: "includeClasses",
        values: newClasses,
      })
    );
    dispatch(fetchFilteredGraphData({ userId: userId }));
  };

  const handleNodeSelectionChange = async (e) => {
    setSelectedNodeKeys(e.value);
    dispatch(setIsCopyLink(false));
    dispatch(setSelectedLeafClasses());

    const selectedClasses = Object.keys(e.value)
      .filter((key) => e.value[key].checked)
      .map((key) => {
        const node = findNodeByKey(nodes, key);
        return node ? node.label : null;
      })
      .filter((label) => label !== null);

    setIsClassNodesLoading(true); // Start loading
    try {
      if (selectedClasses.length > 0) {
        dispatch(setIncludeClasses(selectedClasses));

        await dispatch(
          fetchGraphDataThunk({ userId, selectedClasses })
        ).unwrap();
      } else {
        if (filters.includeKeywords.size > 0) {
          dispatch(setIncludeClasses());
          const newTags = Array.from(filters.includeKeywords);
          await dispatch(handleTagChangeThunk({ userId, newTags })).unwrap();
        } else {
          dispatch(setIncludeClasses());
          dispatch(clearGraphData());
        }
      }
      // handleAddClasses(selectedClasses);
    } catch (error) {
      console.error("Error handling node selection change:", error);
    } finally {
      setIsClassNodesLoading(false); // Stop loading
    }
  };

  const handleTopicSelectionChange = async (e) => {
    // dispatch(clearAllFilters());
    setIsTopicNodesLoading(true); // Start loading
    setSelectedTopicKeys(e.value);

    const selectedTopics = Object.keys(e.value)
      .filter((key) => e.value[key])
      .map((key) => {
        const node = findNodeByKey(topics, key);
        return node ? node.label : null;
      })
      .filter((label) => label !== null);

    try {
      if (selectedTopics.length > 0) {
        dispatch(setSelectedLeafClasses(selectedTopics));
        await dispatch(
          handleTopicSelectionThunk({
            userId: userId,
            selectedTopics: selectedTopics,
          })
        ).unwrap();
      } else {
        dispatch(clearGraphData());

        dispatch(setSelectedLeafClasses());
      }
      dispatch(setIncludeTopics(selectedTopics));
    } catch (error) {
      console.error("Error handling topic selection change:", error);
    } finally {
      setIsTopicNodesLoading(false); // End loading
    }
  };

  const findNodeByKey = (nodes, key) => {
    for (let node of nodes) {
      if (node.key === key) return node;
      if (node.children) {
        const found = findNodeByKey(node.children, key);
        if (found) return found;
      }
    }
    return null;
  };

  const handleNodeToggle = (e) => {
    setExpandedNodeKeys(e.value);
  };

  const handleTopicToggle = (e) => {
    setExpandedTopicKeys(e.value);
  };

  // Function to toggle the dropdown
  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  // Function to handle clicks outside of the dropdown
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  // Set up event listener for clicks outside of the dropdown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Function to download the user guide
  const downloadUserGuide = async () => {
    try {
      const response = await api.get("/uploads/Mattersmith.pdf", {
        responseType: "blob", // Important: set responseType to blob
        headers: {
          Authorization: `Token ${localStorage.getItem("authToken")}`,
        },
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: response.data.type });
        const fileName = "Mattersmith.pdf";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();

        // Clean up by revoking the blob URL
        window.URL.revokeObjectURL(link.href);
      } else {
        console.error("Failed to fetch the file");
      }
    } catch (error) {
      console.error("An error occurred while downloading the file:", error);
    }
  };

  const handleEditorClick = () => {
    if (!isSuperAdmin) {
      setIsEditorMode(true);
      dispatch(updateCurrentRole("editor"));
      localStorage.setItem("currentRole", "editor");
      toast.success("Switched to Editor mode");
    }
  };

  const handleViewerClick = () => {
    if (!isSuperAdmin) {
      setIsEditorMode(false);
      dispatch(updateCurrentRole("viewer"));
      localStorage.setItem("currentRole", "viewer");
      toast.success("Switched to Viewer mode");
    }
  };

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleButtonClick = (viewType) => {
    setViewType(viewType); // Set the view type (Schema, Topics, Playbook)
  };

  const handleLogout = async () => {
    try {
      await dispatch(logoutThunk(REACT_APP_LOGIN_REDIRECT_URL)).unwrap();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleCollapse = () => {
    dispatch(toggleCollapseAll());
  };

  const HandlePreserveFilters = () => {
    setPreserveFilters(!preserveFilters);
  };

  const redirectToHomePage = () => {
    window.location.reload();
  };

  const renderNodeWithTooltip = (node) => {
    return (
      <div
        title={node.description} // Dynamically setting the title to the node description
        data-bs-toggle="tooltip" // Activating tooltip
        data-bs-placement="top" // Tooltip position (top, bottom, left, right)
      >
        {node.label} {/* Display node label */}
      </div>
    );
  };

  return (
    <div
      className={`sidebar px-0 overflow-x-clip relative h-screen  ${
        isExpanded ? "expanded overflow-hidden " : "collapsed"
      }`}
    >
      <FileUploadModal isOpen={modalOpen} toggle={toggleModal} />

      <div
        className={`px-2 h-screen  ${
          isExpanded ? " overflow-y-auto" : ""
        } pr-4 thin-scrollbar horizon-scroller`}
        height={"100vh"}
      >
        <div className="logo d-flex align-items-center gap-5 justify-content-center mb-3">
          {
            isExpanded && (
              // <a href="./">
              <img
                onClick={() => redirectToHomePage()}
                src={knowledgeLogo}
                alt="Knowledge"
                className="hand-cursor"
              />
            )
            // </a>
          }

          <div
            className={`${isExpanded ? "dropdown" : "dropdownExp"}`}
            ref={dropdownRef}
            direction={"right"}
          >
            <button className="dropbtn p-0" onClick={toggleDropdown}>
              <CgMenu />
            </button>
            <div
              className={`  ${
                isExpanded ? "dropdown-content" : "dropdown-contentExp"
              } ${isDropdownOpen ? "show" : ""}`}
            >
              {user?.userRole === "superuser" && (
                <Link onClick={toggleModal}>Upload User Guide</Link>
              )}
              <Link to="/" onClick={downloadUserGuide}>
                Download User Guide
              </Link>
              <Link to="/admin-settings">Admin Settings</Link>
            </div>
          </div>
        </div>

        {isExpanded && (
          <div className="d-flex gap-2 justify-content-between mb-3 ">
            <ButtonGroup size="sm" className="mb-0 w-100">
              <Button
                className={`fs-15 border-teal-light ${
                  viewType === "Schema" ? "active-tabs" : "bg-teal"
                }`}
                onClick={() => handleButtonClick("Schema")}
                title="Display the class schema in the right hand panel."
              >
                Schema
              </Button>
              <Button
                className={`fs-15 border-teal-light ${
                  viewType === "Topics" ? "active-tabs" : "bg-teal"
                }`}
                onClick={() => handleButtonClick("Topics")}
                title="Display the available Topics in the right hand panel."
              >
                Topics
              </Button>
              <Button
                className={`fs-15 border-teal-light ${
                  viewType === "Playbook" ? "active-tabs" : "bg-teal"
                }`}
                onClick={() => handleButtonClick("Playbook")}
                title="Display the current Playbook in the right hand panel."
              >
                Playbook
              </Button>
            </ButtonGroup>
            <Button
              title="Reset to an empty graph."
              className="fs-14 bg-orange border-orange"
              variant="primary"
              size="sm"
              active
              onClick={handleResetAll}
            >
              <i className="ri-close-large-fill"></i>
            </Button>
          </div>
        )}

        {isExpanded && (
          <div className="tree-container">
            <div className="tree-wrapper">
              <Tree
                value={nodes}
                filter
                filterMode="lenient"
                filterPlaceholder="Classes"
                className="custom-tree px-2 pt-4 pb-0"
                selectionMode="checkbox"
                selectionKeys={selectedNodeKeys}
                onSelectionChange={handleNodeSelectionChange}
                expandedKeys={expandedNodeKeys}
                onToggle={handleNodeToggle}
                propagateSelectionDown={false}
                propagateSelectionUp={false}
                emptyMessage={
                  nodes.length === 0 ? (
                    <div className="d-flex justify-content-center">
                      <Spinner animation="border" size="sm" />
                    </div>
                  ) : (
                    <div className="text-center">No records found</div>
                  )
                }
                disabled={isClassNodesLoading}
              />
            </div>
            <div className="tree-wrapper mb-2">
              <Tree
                value={topics}
                filter
                filterMode="lenient"
                filterPlaceholder="Topics"
                className="custom-tree px-2 pt-4 pb-0"
                selectionMode="checkbox"
                selectionKeys={selectedTopicKeys}
                onSelectionChange={handleTopicSelectionChange}
                expandedKeys={expandedTopicKeys}
                onToggle={handleTopicToggle}
                propagateSelectionDown={false}
                propagateSelectionUp={false}
                emptyMessage={
                  topics.length === 0 ? (
                    <div className="d-flex justify-content-center">
                      <Spinner animation="border" size="sm" />
                    </div>
                  ) : (
                    <div className="text-center">No records found</div>
                  )
                }
                disabled={isTopicNodesLoading}
                nodeTemplate={renderNodeWithTooltip} // Use the custom node template for tooltip
              />
            </div>
          </div>
        )}

        {isExpanded && (
          <div
            data-bs-toggle="tooltip"
            title="See the Selected Documents"
            style={{ width: "fit-content" }}
          >
            <Button
              title="See the Selected Documents"
              className="fs-14 bg-white text-darkblue border-light-subtle mb-2 hand-cursor"
              variant="primary"
              size="sm"
              active
              disabled={attachments?.length === 0}
              onClick={() => setShowDraftModals(true)}
            >
              <FaDownload />
            </Button>
          </div>
        )}

        {isExpanded && (
          <div className="d-flex gap-2 justify-content-between">
            <ButtonGroup size="sm" className="mb-0 w-100">
              <div
                className="d-flex flex-fill"
                data-bs-toggle="tooltip"
                title="Hide all nodes and their neighbors that were manually expanded but no longer included by other filters."
              >
                <Button
                  className="fs-14 bg-white text-darkblue border-light-subtle w-100 rounded-end-0 py-1"
                  disabled={expandedNodesCount === 0}
                  onClick={handleCollapse}
                  data-bs-toggle="tooltip"
                  title="Hide all nodes and their neighbors that were manually expanded but no longer included by other filters."
                >
                  Collapse <span className="badge">{expandedNodesCount}</span>
                </Button>
              </div>
              <div
                className="d-flex flex-fill"
                data-bs-toggle="tooltip"
                title="Unpin all nodes that were manually pinned but no longer included by the other filters."
              >
                <Button
                  className="fs-14 bg-white text-darkblue border-light-subtle w-100 rounded-0 py-1"
                  disabled={pinnedNodes.size === 0}
                  onClick={handleUnpinAll}
                  data-bs-toggle="tooltip"
                  title="Unpin all nodes that were manually pinned but no longer included by the other filters."
                >
                  Unpin <span className="badge">{pinnedNodes.size}</span>
                </Button>
              </div>
              <div
                className="d-flex flex-fill"
                data-bs-toggle="tooltip"
                title="Reset filters so that only pinned and expanded nodes are shown."
              >
                <Button
                  className="fs-14 bg-white text-darkblue border-light-subtle w-100 rounded-start-0 py-1"
                  disabled={totalNodesCount === 0}
                  onClick={handleReset}
                  data-bs-toggle="tooltip"
                  title="Reset filters so that only pinned and expanded nodes are shown."
                >
                  Reset{" "}
                  <span className="badge">
                    {/* {totalNodesCount - pinnedNodes.size > 0
                        ? totalNodesCount - pinnedNodes.count
                        : 0} */}
                    {totalNodesCount}
                  </span>
                </Button>
              </div>
            </ButtonGroup>
          </div>
        )}
        <hr />
        <div className="footer">
          {isExpanded && (
            <p className="mb-1">
              User {user?.username}, in{" "}
              {isSuperAdmin ? "superuser" : isEditorMode ? "editor" : "viewer"}{" "}
              mode
            </p>
          )}
          {isExpanded && (
            <div className="d-flex align-items-center gap-2 mb-3">
              <strong>Mode:</strong>
              <ButtonGroup size="sm" className="mb-0 d-inline-flex">
                <Button
                  className={`fs-14 ${
                    isEditorMode || isSuperAdmin
                      ? "bg-blue text-white cursor-not-allowed"
                      : "bg-white text-darkblue hand-cursor"
                  } border-light-subtle px-2 py-0`}
                  onClick={handleEditorClick}
                  disabled={isSuperAdmin || isEditorMode || role === "viewer"}
                >
                  Editor
                </Button>
                <Button
                  className={`fs-14 ${
                    !isEditorMode && !isSuperAdmin
                      ? "bg-blue text-white cursor-not-allowed"
                      : "bg-white text-darkblue hand-cursor"
                  } border-light-subtle px-2 py-0`}
                  onClick={handleViewerClick}
                  disabled={isSuperAdmin || !isEditorMode}
                >
                  Viewer
                </Button>
              </ButtonGroup>
              <div className="mb-0 d-inline-flex gap-1 items-center">
                <input
                  type="checkbox"
                  id="preserveFilters"
                  checked={preserveFilters}
                  onChange={HandlePreserveFilters}
                />
                <label htmlFor="preserveFilters">Preserve Filters</label>
              </div>
            </div>
          )}
        </div>
        {!isExpanded && (
          <div className="flex collapsed-sidebar">
            <div className="d-flex justify-content-center ">
              <img src={knowledgeshortLogo} alt="short-logo" />
            </div>
            <ul className="h-screen">
              <li className="pb-2">
                <div>
                  <Button
                    className="fs-15 bg-teal border-teal-light"
                    onClick={() => handleButtonClick("Schema")}
                    title="Display the class schema in the right hand panel."
                  >
                    <PiTreeStructureThin size={18} />
                  </Button>
                </div>
              </li>
              <li className="pb-2">
                <div>
                  <Button
                    className="fs-15 bg-teal border-teal-light"
                    onClick={() => handleButtonClick("Topics")}
                    title="Display the available Topics in the right hand panel."
                  >
                    <BsCardHeading size={18} />
                  </Button>
                </div>
              </li>
              <li className="pb-2">
                <div>
                  <Button
                    className="fs-15 bg-teal border-teal-light"
                    onClick={() => handleButtonClick("Playbook")}
                    title="Display the current Playbook in the right hand panel."
                  >
                    <FiBook size={18} />
                  </Button>
                </div>
              </li>
              <li>
                <div
                  data-bs-toggle="tooltip"
                  title="See the Selected Documents"
                >
                  <Button
                    title="See the Selected Documents"
                    className="fs-14 bg-white text-darkblue border-light-subtle mb-2 hand-cursor"
                    variant="primary"
                    size="sm"
                    active
                    disabled={attachments?.length === 0}
                    onClick={() => setShowDraftModals(true)}
                  >
                    <FaDownload />
                  </Button>
                </div>
              </li>
              <li className="py-2 ">
                <hr className="bg-white my-1 w-[44px]"></hr>
              </li>
              <li className="pb-4 py-2">
                <div style={{ height: "35px" }}>
                  <Button
                    className="btn fs-14 btn-secondary"
                    // disabled={expandedNodes.size === 0}
                    title="Hide all nodes and their neighbors that were manually expanded but no longer included by other filters."
                    onClick={() => {
                      handleCollapse();
                    }}
                  >
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_8_9)">
                        <path
                          d="M9 6.0615L12.0196 8.64974M12.0196 8.64974L15.0392 6.0615M12.0196 8.64974V1.31641M15.0392 18.5713L12.0196 15.9831M12.0196 15.9831L9 18.5713M12.0196 15.9831L12.0196 23.3164"
                          stroke="white"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6 12.3164L18 12.3164"
                          stroke="white"
                          stroke-linecap="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_8_9">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0 0.681641)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </Button>
                  <span className="badge sidebar-badge">
                    {expandedNodes.size}
                  </span>
                </div>
              </li>

              <li className="pb-4">
                <div style={{ height: "35px" }}>
                  <Button
                    className="btn fs-14 btn-secondary"
                    // disabled={expandedNodes.size === 0}
                    title="Unpin all nodes that were manually pinned but no longer included by the other filters."
                    onClick={() => {
                      handleUnpinAll();
                    }}
                  >
                    <BsFillPinFill size={20} />
                  </Button>
                  <span className="badge sidebar-badge">
                    {pinnedNodes.size}
                  </span>
                </div>
              </li>

              <li className="pb-">
                <div style={{ height: "35px" }}>
                  <Button
                    className="btn fs-14 btn-secondary "
                    title="Reset filters so that only pinned and expanded nodes are shown."
                    // disabled={expandedNodes.size === 0}
                    onClick={handleResetAll}
                  >
                    <GrRefresh size={20} />
                  </Button>
                  <span className="badge sidebar-badge">
                    {totalNodesCount - pinnedNodes.size ?? 0}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        )}
      </div>

      {/* Fixed footer */}
      <div className="h-full">
        <div
          className={`d-flex ${
            isExpanded ? "justify-content-left" : "justify-content-center"
          } px-2`}
        >
          <button
            style={{
              height: "35px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
            }}
            className={`btn btn-primary btn-md mt-2 p-0 bg-white border-white text-darkblue ${
              isExpanded ? "px-2" : "w-33"
            }`}
            onClick={() => {
              handleLogout();
            }}
            outline="true"
          >
            <AiOutlineLogout size={20} className={isExpanded ? "me-2" : ""} />
            {isExpanded ? "Logout" : ""}
          </button>
        </div>
      </div>
      <button
        className={`arrow-icon btn btn-primary btn-sm text-darkblue ${
          isExpanded ? "toggle-sidebar-btn" : "toggle-colllapsed-sidebar-btn"
        }`}
        onClick={toggleSidebar}
      >
        {isExpanded ? <BsChevronDoubleLeft /> : <BsChevronDoubleRight />}
      </button>
    </div>
  );
};

// Scrollbar hiding CSS remains the same
const style = document.createElement("style");
style.textContent = `
  .sidebar {
    transition: width 0.3s ease;
  }
  .sidebar.expanded {
    width: 22%; /* or your desired expanded width */
  }
  .sidebar.collapsed {
    width: 70px; /* or your desired collapsed width */
  }
  .sidebar.collapsed .logo,    
  .sidebar.collapsed .tree-container,
  .sidebar.collapsed .footer {
    display: none;
  }

  .toggle-sidebar-btn{
    width: 24px;
    height: 24px;
    border-radius: 50% !important;
    padding: 0px !important;
    position: absolute;
    bottom: 10px;
    right: 77%;
    
  }

  .toggle-colllapsed-sidebar-btn{
    width: 24px;
    height: 24px;
    border-radius: 50% !important;
    padding: 0px !important;
    position: absolute;
    bottom: 10px;
    right: 94.4%;
  }
    .collapsed-sidebar ul{
      list-style: none;
    margin: 0px;
    padding: 15px 0px;
    
    }
     .collapsed-sidebar li{
        text-align: center;
    }
     .collapsed-sidebar Button{
     width: 35px;
     height: 35px;
     padding : 0px ;
    
    }
     .badge.sidebar-badge{
    position: relative !important;
    background: white;
    color: gray;
    top: -54px;
    right: -8px;
    z-index: 999;
     }

     .thin-scrollbar::-webkit-scrollbar {
    width: 4px;
  }
  .thin-scrollbar::-webkit-scrollbar-track {
    background: #434343;
  }
  .thin-scrollbar::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 2px;
  }
  .thin-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #939393;
  }
`;
document.head.appendChild(style);

export default SidebarComponent;
